import { StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export function getMatchPickStatsStyles(C: WcColors) {
  return StyleSheet.create({
    routeSafeArea: {
      flex: 1,
      backgroundColor: C.bg,
    },
    container: {
      flex: 1,
      backgroundColor: C.bg,
    },
    scrollContent: {
      paddingBottom: 132,
    },
    sectionTitle: {
      fontSize: 11,
      fontWeight: '800',
      color: C.purpleHi,
      textTransform: 'uppercase',
      letterSpacing: 1.4,
    },
    sectionTitleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
    sectionPicksBadge: {
      fontSize: 11,
      fontWeight: '700',
      color: C.inkMute,
      backgroundColor: C.panelHi,
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 99,
      overflow: 'hidden',
    },
    panelCard: {
      marginHorizontal: 16,
      borderRadius: 14,
      backgroundColor: C.panel,
      borderWidth: 1,
      borderColor: C.line,
      overflow: 'hidden',
    },
    sectionWrap: {
      marginTop: 18,
      marginHorizontal: 16,
    },
    loadingSpinner: {
      paddingVertical: 48,
      alignSelf: 'center' as const,
    },
    errorText: {
      fontSize: 14,
      color: C.red,
      textAlign: 'center',
      paddingVertical: 24,
    },
    noPicksText: {
      fontSize: 13,
      color: C.inkMute,
      textAlign: 'center',
      paddingVertical: 24,
    },
  });
}
